const SettingsPage = () => {
  return <h1>Settings</h1>;
};

export default SettingsPage; 